<template>
  <b-form-group
    :label="$t('form.phone.label')"
    label-for="user-profile-phone"
    :class="{ 'text-muted delete-margin-block': isRegister }"
  >
    <vue-tel-input
      id="user-profile-phone"
      v-model="phone"
      name="user-profile-phone"
      :input-classes="inputClasses"
      :wrapper-classes="['tel-input-wrapper', customClass]"
      :placeholder="$t('form.phone.label')"
      :preferred-countries="['ua', 'ru', 'by', 'us', 'de']"
      :valid-characters-only="true"
      @validate="validate"
    ></vue-tel-input>
    <div
      v-if="validState && showInvalidMsg"
      id="input-phone-feedback"
      class="invalid-feedback"
      style="display: block"
    >
      {{ $t('message.error.invalidPhone') }}
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: 'PhoneNumberFormGroup',
  components: {
    VueTelInput: () => import('vue-tel-input').then((c) => c.VueTelInput),
  },
  props: ['value', 'validState', 'customClass', 'isRegister'],
  data() {
    return {
      showInvalidMsg: null,
      invalidSubmit: false,
    };
  },
  computed: {
    phone: {
      get: function () {
        return this.value || '';
      },
      set: function (v) {
        this.$emit('input', v);
      },
    },
    inputClasses() {
      let classes = ['tel-input-input', this.customClass];

      if (this.validState) {
        if (!this.showInvalidMsg) {
          classes.push('tel-input-valid');
        } else {
          classes.push('tel-input-invalid');
        }
      }

      return classes;
    },
  },
  methods: {
    validate(e) {
      this.$emit('validate', e.isValid);
      this.showInvalidMsg = !e.isValid;
    },
  },
};
</script>

<style lang="scss" scoped></style>
